<template>
  <PageTitleComponent
    v-if="range && range.label"
    :title="getTranslation(500) + ' ' + range.label"
  />
  <div v-if="range" class="range">
    <div class="range__img">
      <img
        v-if="range.photo_tv"
        :alt="range.label"
        :src="imageManager().picture(range.photo_tv, 'tv_zoom')"
      />
    </div>
    <SideBarComponent>
      <template v-slot:content>
        <div class="range__title">
          <div class="range__label">
            <span class="e-aixam -model" v-html="processVehicleLabel()"></span>
          </div>
          <div v-if="range.energies" class="range__sub">
            {{ range.energies.join(" - ") }}
          </div>
          <div v-if="range.fromInstallment" class="range__price">
            {{
              getTranslation(488, {
                PRICE: formatPrice(range.fromInstallment),
                CURRENCY: currency,
              })
            }}
          </div>
        </div>
        <div
          ref="text"
          class="range__text"
          style="line-height: 40px"
          v-html="truncate(html)"
        ></div>
        <button
          v-if="displayReadMoreButton"
          class="range__more"
          @click="readMore"
        >
          {{ getTranslation(16) }}
          <img src="/assets/images/svg/chevron-left-solid.svg" />
        </button>
        <router-link
          :to="{ name: 'Types', params: { range: this.$route.params.range } }"
          class="range__vehicle button"
          >{{ getTranslation(475).replace("__RANGE__", "") }}
        </router-link>
      </template>
    </SideBarComponent>
  </div>
  <ModalComponent
    v-if="range && range.label"
    :content="html"
    :opened="modalOpened"
    :title="getTranslation(500) + ' ' + range.label"
    @hidden="modalHidden"
  />
</template>

<script>
import { mapActions, mapState } from "pinia";
import PageTitleComponent from "@/components/PageTitleComponent.vue";
import SideBarComponent from "@/components/SideBarComponent.vue";
import { priceManager } from "@/services/price-manager";
import { vehicleManager } from "@/services/vehicle-manager";
import ModalComponent from "@/components/ModalComponent.vue";
import { useMainStore } from "@/store";
import clip from "text-clipper";
import { getTranslation } from "@/services/translation-manager";
import { imageManager } from "@/services/image-manager";

export default {
  name: "ModelsView",
  components: { ModalComponent, SideBarComponent, PageTitleComponent },
  data() {
    return {
      html: "",
      modalOpened: false,
      displayReadMoreButton: false,
    };
  },
  computed: {
    ...mapState(useMainStore, {
      range: (store) => store.range,
      ranges: (store) => store.ranges,
      currency: (store) => store.currency,
    }),
  },
  watch: {
    ranges() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    imageManager() {
      return imageManager;
    },
    init() {
      this.toggleRange(this.$route.params.range);
      this.setHtml();
    },

    truncate(content) {
      const ret = clip(content, 530, { html: true, maxLines: 12 });
      if (ret.length < content.length) {
        this.displayReadMoreButton = true;
      }
      return ret;
    },

    readMore() {
      this.modalOpened = true;
    },

    modalHidden() {
      this.modalOpened = false;
    },

    formatPrice(price) {
      return priceManager.format(price);
    },

    processVehicleLabel() {
      return vehicleManager.processLabel(this.range.label);
    },

    setHtml() {
      if (this.range && this.range.text) {
        const regex = new RegExp(/((src|href)=(["']))([/.]+)*/g);
        this.html = this.range.text
          .replace(regex, "$1" + process.env.VUE_APP_API_URL + "/")
          .replace(/__MODELS__/g, "");
      }
    },

    getTranslation(id, params = {}) {
      return getTranslation(id, params);
    },

    ...mapActions(useMainStore, ["toggleRange"]),
  },
};
</script>

<style lang="scss" scoped>
.range {
  color: $white;
  height: 100%;

  &__img {
    height: 100%;
    width: 71%;
    clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
    position: relative;

    img {
      height: 100%;
    }
  }

  &__title {
    border-left: 1px solid $white;
    padding-left: 15px;
  }

  &__label {
    font-size: 45px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 0.8;
    margin-bottom: 10px;
  }

  &__price {
    font-weight: 700;
    font-size: 16px;
    line-height: 0.8;
    margin-top: 12px;
  }

  &__text {
    margin: 40px 0;
    font-size: 20px;
    line-height: 2;
    overflow: hidden;
    font-family: $font-roboto;
  }

  &__more {
    border: none;
    border-top: 1px solid $white;
    background: none;
    display: flex;
    align-items: center;
    color: $white;
    margin-bottom: 40px;
    padding-top: 5px;
    font-size: 16px;

    img {
      transform: rotate(180deg);
      width: 8px;
      margin-left: 20px;
    }
  }
}
</style>
